(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/vegas-communication.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/vegas-communication.js');
'use strict';

const {
  Fieldset
} = svs.ui.reactForm;
const title = 'Vegas';

const VegasCommunication = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("h3", {
    className: "h3 margin-bottom-1 padding-top"
  }, React.createElement("span", {
    className: "f-medium"
  }, "Vegas ")), React.createElement("p", null, "Vill du ha direktmarknadsf\xF6ring med nyheter och annan information fr\xE5n Vegas?"), React.createElement(Fieldset, {
    legend: title,
    srOnly: true
  }, children));
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.components.VegasCommunication = VegasCommunication;

 })(window);